import Vue from 'vue'
import Router from 'vue-router'

const Login = ()=> import('@/components/Login');
const CheckLogin = ()=> import('@/components/CheckLogin');
const Error = ()=> import('@/components/Error')

const Download = ()=> import('@/components/download/Download')
const Calendar = ()=> import('@/components/calendar/Calendar')
const Map = ()=> import('@/components/map/map')

const GroupList = ()=> import('@/components/admin/groupList/GroupList')
const GroupEdit = ()=> import('@/components/admin/groupEdit/GroupEdit')
const GroupSection = ()=> import('@/components/admin/groupEdit/section/GroupSection')
const GroupPermissionSection = ()=> import('@/components/admin/groupEdit/section/PermissionSection')

const ClientList = ()=> import('@/components/admin/clientList/ClientList')
const ClientEdit = ()=> import('@/components/admin/clientEdit/ClientEdit')
const ClientSection = ()=> import('@/components/admin/clientEdit/section/ClientSection')
const ClientPermissionSection = ()=> import('@/components/admin/clientEdit/section/PermissionSection')
const ClientUserSection = ()=> import('@/components/admin/clientEdit/section/UserSection')

const Stats = ()=> import('@/components/admin/stats/Stats')
const StatsUserSection = ()=> import('@/components/admin/stats/section/UserSection')
const StatsMBFDSection = ()=> import('@/components/admin/stats/section/MBFDSection')

const UserList = ()=> import('@/components/admin/userList/UserList')
const UserEdit = ()=> import('@/components/admin/userEdit/UserEdit')
const UserSection = ()=> import('@/components/admin/userEdit/section/UserSection')
const UserAddressSection = ()=> import('@/components/admin/userEdit/section/AddressSection')

const GlobalFiles = ()=> import('@/components/globalFiles/GlobalFiles')

const ContractList = ()=> import('@/components/contract/contractList/ContractList')
const ContractEdit = ()=> import('@/components/contract/contractEdit/ContractEdit')
const ContractSection = ()=> import('@/components/contract/contractEdit/section/ContractSection')
const ContractAddressSection = ()=> import('@/components/contract/contractEdit/section/AddressSection')
const CostcenterSection = ()=> import('@/components/contract/contractEdit/section/CostcenterSection')
const PositionSection = ()=> import('@/components/contract/contractEdit/section/PositionSection')

const OrderList = ()=> import('@/components/order/orderList/OrderListStatus')
const OrderImport = ()=> import('@/components/order/orderList/OrderImport')

const Manual = ()=> import('@/components/manual/Manual')

const OrderEdit = ()=> import('@/components/order/orderEdit/OrderEdit')
const OrderSection = ()=> import('@/components/order/orderEdit/section/Order')
const HierarchySection = ()=> import('@/components/order/orderEdit/section/Hierarchy')
const DocumentsSection = ()=> import('@/components/order/orderEdit/section/documents/Documents')
const MBFDSection = ()=> import('@/components/order/orderEdit/section/mbfd/MBFD')
const DocumentationSection = ()=> import('@/components/order/orderEdit/section/Documentation')
const UploadSection = ()=> import('@/components/order/orderEdit/section/Upload')
const AssignmentSection = ()=> import('@/components/order/orderEdit/section/Assignment')
const MaterialSection = ()=> import('@/components/order/orderEdit/section/material/Material')
const AbrechnungSection = ()=> import('@/components/order/orderEdit/section/abrechnung/Abrechnung')
const AbrechnungSubSection = ()=> import('@/components/order/orderEdit/section/abrechnung/AbrechnungSection')
const MeasurementSubSection = ()=> import('@/components/order/orderEdit/section/abrechnung/measurement/MeasurementSection')
const MeasurementListSubSubSection = ()=> import('@/components/order/orderEdit/section/abrechnung/measurement/MeasurementList')
const MeasurementSubSubSection = ()=> import('@/components/order/orderEdit/section/abrechnung/measurement/Measurement')

Vue.use(Router)

const router = new Router({
	  routes: [
		    {
		    	path: '/',
		    	component: OrderList,
		    	meta: {permissions: ['seeOrders', 'seeAssignedOrders', 'editOrders', 'editAssignedOrders']}
		    },
		    {
		    	path: '/login',
		    	component: Login,
		    	meta: {requiresNoAuth: true}
		    },
		    {
		        path: '/checkLogin',
		        component: CheckLogin,
		        meta: {requiresNoAuth: true}
		    },
		    {
		      path: '/admin/userList/',
		      component: UserList,
		      meta: {permissions: ['seeUser', 'editUser']}
		    },
		    {
		      path: '/admin/groupList',
		      component: GroupList,
		      meta: {permissions: ['seeGroups', 'editGroups']}
		    },

		    {
		      path: '/admin/groupEdit/:id',
		      component: GroupEdit,
		      meta: {permissions: ['seeGroups', 'editGroups']},
		      children: [
		    	  {
		              path: 'group',
		              component: GroupSection
		    	  },
		    	  {
		    		  path: 'permission',
		    		  component: GroupPermissionSection

		    	  },
		    	  {
		              path: '',
			 		  beforeEnter: (to, from, next) => {
			 			 next({
			 				 path: to.path+"group"
			 			 })
			 		  }
		    	  },
		      ]

		    },

			{
		  	  path: '/admin/clientEdit/:id',
		  	  component: ClientEdit,
		  	  meta: {permissions: ['seeClients', 'editClients']},
		  	  children: [
		  		 {
		  			 path:'client',
		  			 component: ClientSection
		  		 },
		    	 {
		    		 path: 'permission',
		    		 component: ClientPermissionSection

		    	 },
		    	 {
		    		 path: 'user',
		    		 component: ClientUserSection

		    	 },
		  		 {
		  			 path:'',
			 		 beforeEnter: (to, from, next) => {
			 			 next({
			 				 path: to.path+"client"
			 			 })
			 		 }
		  		 }
		  	  ]
		    },
		    {
		      path: '/admin/stats/',
		      component: Stats,
		      children: [
			     {
			    	 path:'user',
			    	 component: StatsUserSection
			 	 },
			 	 {
			 		 path:'',
			 		 beforeEnter: (to, from, next) => {
			 			 next({
			 				 path: to.path+"user"
			 			 })
			 		 }
			 	 }
			   ]
		     },

		    {
		      path: '/admin/userEdit/:id',
		      component: UserEdit,
		      meta: {permissions: ['seeUser', 'editUser', 'selfUser']},
		      children: [
		 	     {
		 	    	 path:'user',
		 	    	 component: UserSection,
		 	 	 },
		 	 	 {
		 	 		 path:'address',
		 	 		 component: UserAddressSection,
		 	 	 },
			 	 {
			 		 path:'',
			 		 beforeEnter: (to, from, next) => {
			 			 next({
			 				 path: to.path+"user"
			 			 })
			 		 }
			 	 }
		 	   ]
		    },
		    {
			  path: '/admin/clientList',
			  component: ClientList,
			  meta: {permissions: ['seeClients', 'editClients']}
			},
		    {
			  path: '/globalFiles/',
			  component: GlobalFiles,
			  meta: {permissions: ['seeGlobalFiles']}
			},
		    {
		      path: '/contract/contractEdit/:id',
		      component: ContractEdit,
		      meta: {permissions: ['seeContracts', 'seeContracts']},
		      children: [
		  	     {
		  	    	 path:'contract',
		  	    	 component: ContractSection
		  	 	 },
		  	 	 {
		  	 		 path:'address',
		  	 		 component: ContractAddressSection
		  	 	 },
		  	 	 {
		  	 		 path:'costcenter',
		  	 		 component: CostcenterSection
		  	 	 },
		  	 	 {
		  	 		 path:'position',
		  	 		 component: PositionSection
		  	 	 },
		 	 	 {
		 	 		 path:'',
			 		 beforeEnter: (to, from, next) => {
			 			 next({
			 				 path: to.path+"contract"
			 			 })
			 		 }
		 	 	 }
		  	   ]
		    },
		    {
		      path: '/contract/contractList/',
		      component: ContractList,
		      meta: {permissions: ['seeContracts', 'seeContracts']},
		    },
		    {
		      path: '/order/orderList',
		      component: OrderList,
		      meta: {permissions: ['seeOrders', 'seeAssignedOrders', 'editOrders', 'editAssignedOrders']}
		    },
		    {
			  path: '/order/orderList/orderImport',
			  component: OrderImport
			},
		    {
		      path: '/order/orderEdit/:id',
		      component: OrderEdit,
		      meta: {permissions: ['seeOrders', 'seeAssignedOrders', 'editOrders', 'editAssignedOrders']},
		      children: [
		   	     {
		   	    	 path:'order',
		   	    	 component: OrderSection
		   	 	 },
		   	 	 {
		   	 		 path:'hierarchy',
		   	 		 component: HierarchySection,
		   	 		 meta: {permissions: ['seeOrderHierachy', 'editOrderHierachy']},
		   	 	 },
		   	 	 {
		   	 		 path:'assignment',
		   	 		 component: AssignmentSection,
		   	 		 meta: {permissions: ['editClientAssignment', 'editUserAssignment']},

		   	 	 },
		   	 	 {
		   	 		 path:'documents',
		   	 		 component: DocumentsSection,
		   	 		 meta: {permissions: ['seeQualityDocuments']},
		   	 	 },
		   	 	 {
		   	 		 path:'mbfd',
		   	 		 component: MBFDSection,
		   	 		 meta: {permissions: ['editMBFD', 'seeMBFD']},
		   	 	 },
		   	 	 {
		   	 		 path:'documentation',
		   	 		 component: DocumentationSection,
		   	 		 //meta: {permissions: ['seeOrderDownloads']},
		   	 	 },
		   	 	 {
		   	 		 path:'upload',
		   	 		 component: UploadSection,
		   	 		 meta: {permissions: ['seeOrderDownloads']},
		   	 	 },
		   	 	 {
		   	 		 path:'material',
		   	 		 component: MaterialSection,
		   	 		 meta: {permissions: ['materialOrder']}
		   	 	 },
		   	 	{
		   	 		 path:'abrechnung',
		   	 		 component: AbrechnungSection,
		   	 		 meta: {permissions: ['seeAccounting']},
		   	 	 	 children: [
		   	 			 {
		   	 				 path: 'abrechnung',
		   	 			     component: AbrechnungSubSection,
		   	 			 },
		   	 			 {
		   	 				 path: '/',
					 		 beforeEnter: (to, from, next) => {
					 			 next({
					 				 path: to.path+"/abrechnung"
					 			 })
					 		 }
		   	 			 },
		   	 			 {
		   	 				 path: 'measurement',
		   	 			     component: MeasurementSubSection,
				   	 	 	 children: [
				   	 			 {
				   	 				 path: 'measurementList',
				   	 			     component: MeasurementListSubSubSection,
				   	 			 },
				   	 			 {
				   	 				 path: '/',
							 		 beforeEnter: (to, from, next) => {
							 			 next({
							 				 path: to.path+"/measurementList"
							 			 })
							 		 }
				   	 			 },
				   	 			 {
				   	 				 path: 'measurement/:measurementId',
				   	 			     component: MeasurementSubSubSection,
				   	 			 },
				   	 	 	 ]
		   	 			 },
		   	 	 	 ]
		   	 	 },
		  	 	 {
		  	 		 path:'',
			 		 beforeEnter: (to, from, next) => {
			 			 next({
			 				 path: to.path+"order"
			 			 })
			 		 }
		  	 	 }
		   	   ]
		    },
		    {
		      path: '/download',
		      component: Download,
		      meta: {permissions: ['seeGlobalDownload']}
		    },
		    {
		      path: '/calendar',
		      component: Calendar
		    },
		    {
		      path: '/map',
		      component: Map,
		      meta: {permissions: ['seeGlobalMap']}
		    },
		    {
			  path: '/manual/:section',
			  component: Manual
			},
		    {
		      path: "*",
		      component: Error,
		    }
		  ]
		});


router.beforeEach((to, from, next) => {
	if(!Vue.$auth.isLoggedIn()){
		if(to.matched[0].meta.requiresNoAuth) {
			next();
		} else {
			next({
				path: '/checkLogin',
	        	query: {redirect: to.fullPath}
			})
		}
	} else {
		if(to.matched[0].meta.requiresNoAuth) {
			next({
				path: from.fullPath
			});
		} else {
			var permission = true;
			to.matched.forEach((entry) => {
				if(entry.meta.permissions !== undefined) {
					if(!Vue.$auth.hasPermission.apply(null, entry.meta.permissions)) {
						permission = false;
					}
				}
			});

			if(permission) {
				next();
			} else {
				next({
					path: '/error',
		        	query: {redirect: to.fullPath}
				})
			}
		}
	}
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js